export const releasesEn = {
  "title": "Update history",
  "system": "System information",
  "description": "Confirmed successful deployments and their release notes. Times use your current time zone.",
  "browserVersion": "Version running in this browser",
  "latest": "Latest confirmed deployment",
  "dev": "Dev local",
  "untracked": "Untracked build",
  "pending": "Deployment date not yet available",
  "devHint": "Local development build. The deployment history below belongs to production.",
  "untrackedHint": "This build has no deployment record attached.",
  "unknownDate": "Deployment date unavailable",
  "openVersion": "View version {{version}} and update history",
  "viewHistory": "View update history",
  "updateAvailable": "The system has been updated to v{{version}}. Reload when your work is saved.",
  "reload": "Reload",
  "later": "Later",
  "reloadTitle": "Reload the application?",
  "saveFirst": "Save your work before reloading. Unsaved changes may be lost. Existing page warnings will still apply; the system never reloads automatically.",
  "savedReload": "Work saved — reload",
  "loadError": "Could not load deployment information.",
  "empty": "No confirmed deployments have been recorded yet.",
  "thisBrowser": "This browser",
  "serving": "Serving now",
  "imported": "Earlier deployment verified from deployment records; older releases reused the same version number.",
  "previous": "Previous",
  "next": "Next",
  "page": "Page {{page}} of {{pages}}",
  "pagination": "Release history pagination"
};
export const releasesVi = {
  "title": "Nhật ký cập nhật",
  "system": "Thông tin hệ thống",
  "description": "Các lần triển khai thành công và nội dung cập nhật. Thời gian theo múi giờ bạn đang sử dụng.",
  "browserVersion": "Phiên bản trình duyệt đang chạy",
  "latest": "Lần triển khai thành công mới nhất",
  "dev": "Dev local",
  "untracked": "Bản chưa ghi nhận",
  "pending": "Chưa có ngày triển khai",
  "devHint": "Đây là bản phát triển local. Lịch sử triển khai bên dưới thuộc production.",
  "untrackedHint": "Bản này chưa được gắn thông tin triển khai.",
  "unknownDate": "Chưa có thông tin ngày triển khai",
  "openVersion": "Xem phiên bản {{version}} và nhật ký cập nhật",
  "viewHistory": "Xem nhật ký cập nhật",
  "updateAvailable": "Hệ thống đã cập nhật lên v{{version}}. Hãy tải lại sau khi lưu công việc.",
  "reload": "Tải lại",
  "later": "Để sau",
  "reloadTitle": "Tải lại ứng dụng?",
  "saveFirst": "Hãy lưu công việc trước khi tải lại. Thay đổi chưa lưu có thể bị mất. Cảnh báo sẵn có của trang vẫn được giữ; hệ thống không tự tải lại.",
  "savedReload": "Đã lưu xong — tải lại",
  "loadError": "Không tải được thông tin triển khai.",
  "empty": "Chưa có lần triển khai thành công nào được ghi nhận.",
  "thisBrowser": "Trình duyệt này",
  "serving": "Đang phục vụ",
  "imported": "Bản triển khai cũ đã được đối chiếu với lịch sử triển khai; các bản cũ dùng chung số phiên bản.",
  "previous": "Trước",
  "next": "Sau",
  "page": "Trang {{page}} / {{pages}}",
  "pagination": "Phân trang nhật ký cập nhật"
};
export const releasesZh = {
  "title": "更新记录",
  "system": "系统信息",
  "description": "已确认成功的部署与更新说明。时间依目前时区显示。",
  "browserVersion": "此浏览器当前运行的版本",
  "latest": "最近确认成功的部署",
  "dev": "本地开发",
  "untracked": "未追踪的版本",
  "pending": "尚无部署日期",
  "devHint": "这是本地开发版本。下方部署历史属于正式环境。",
  "untrackedHint": "此版本尚未附加部署记录。",
  "unknownDate": "尚无部署日期信息",
  "openVersion": "查看版本 {{version}} 与更新记录",
  "viewHistory": "查看更新记录",
  "updateAvailable": "系统已更新至 v{{version}}。保存工作后即可重新加载。",
  "reload": "重新加载",
  "later": "稍后",
  "reloadTitle": "重新加载应用程序？",
  "saveFirst": "请先保存工作。未保存的变更可能丢失，页面原有的警告仍然有效；系统不会自动重新加载。",
  "savedReload": "已保存工作 — 重新加载",
  "loadError": "无法加载部署信息。",
  "empty": "尚未记录成功的部署。",
  "thisBrowser": "此浏览器",
  "serving": "目前提供服务",
  "imported": "此旧部署已核对部署记录；旧版本曾重复使用相同版本号。",
  "previous": "上一页",
  "next": "下一页",
  "page": "第 {{page}} 页，共 {{pages}} 页",
  "pagination": "更新记录分页"
};